import React from 'react'
import {
  Icon,
  Close,
  InfoOutlined,
  Button,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func } from 'prop-types'

function KodamaNotice({ onClose, ...props }) {
  return (
    <div
      className="
        cgt-mb-10
        cgt-notice-outline
        cgt-notice-outline--primary
        is-medium
        cgt-notice-outline--thick
        kodama-notice
      "
      {...props}
    >
      <div className="cgt-notice__icon-container">
        <Icon
          svgComponent={InfoOutlined}
          className="cgt-notice__icon"
          spaceless
          notSpaced
          color="dark"
        />
      </div>

      <div className="cgt-notice__content kodama-notice__content">
        Verify, export, package, and upload Blender and 3DS Max files directly
        from your software with the Kodama plugin.
        <Button
          type="secondary"
          href="https://wildcat.cgtrader.com/kodama"
          linkAttributes={{ target: '_blank' }}
        >
          Learn more
        </Button>
      </div>

      <div className="cgt-notice__close" onClick={onClose} role="button">
        <Icon
          svgComponent={Close}
          color="dark"
          size="small"
          withHover
          notSpaced
        />
      </div>
    </div>
  )
}

KodamaNotice.propTypes = {
  onClose: func.isRequired,
}

export default KodamaNotice
